import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ForgotPasswordComponent, ForgotPasswordComponentService } from '@spartacus/user/profile/components';
import { SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { UrlPipe, TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'kn-br-forgot-password',
    templateUrl: './kn-br-forgot-password.component.html',
    styleUrls: ['./kn-br-forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpinnerComponent, ReactiveFormsModule, FormErrorsComponent, RouterLink, AsyncPipe, UrlPipe, TranslatePipe]
})
export class KnBrForgotPasswordFormComponent extends ForgotPasswordComponent {
  constructor(protected service: ForgotPasswordComponentService) {
    super(service);
  }
}
